import axios from '@/libs/api.request'
import fileAxios from '@/libs/file.request';
//支付明细列表
export const apiOrderpayList = data => {
    return axios.request({
      url: '/orderpay/list',
      method: 'post',
      data
    })
  }

    // /用户导出
export const apiOrderpayExport = data => {
  return fileAxios.request({
    url: '/orderpay/export',
    method: 'get',
    data
  }, { responseType: 'blob' });
}
//交易明细列表

export const orderpayrefundList = data => {
  return axios.request({
    url: '/orderpayrefund/list',
    method: 'post',
    data
  })
}